module.exports = __webpack_public_path__ + "static/img/3.240692ab.svg";